<template>
  <div class="base-card">
    <slot />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.base-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

</style>